// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainSidebar_sidebarMenuGroups__8dbXJ {
    font-weight: 100;
    height: calc(100vh - 75px);
    padding-top: 15px;
    position: fixed;
    top: 60px;
    box-sizing: border-box;

    --expanded-width: 273px;
    width: var(--expanded-width);
    overflow: auto;

    animation: MainSidebar_expanding__pdaOE 250ms ease;

    &.MainSidebar_collapsed__JUDKb {
        animation: MainSidebar_collapsing__S3tF0 250ms ease 200ms 1 normal forwards;
    }

    &.MainSidebar_mobile__RXDko {
        top: 0;
        --expanded-width: 260px;
        height: 100vh;
    }

    &::-webkit-scrollbar {
        width: 9px;
        height: 0;
    }

    &::-webkit-scrollbar-thumb {
        border-width: 0 2px;
        border-style: solid;
        background-color: var(--color-102);
        border-color: #1a1a1a; /* we don't have this color in ui-connect */
    }

    .MainSidebar_sidebarMenuItems__J6niH {
        margin: 0 0 5px;
        list-style: none;
        padding: 0;
    }

    button {
        padding: 2px 10px;
        color: var(--color-114);
        font-size: 14px;
        margin: 5px 20px 20px;
        border: 1px solid var(--color-102);
        border-radius: 24px;
        width: calc(100% - 40px);
        opacity: 1;
        transition: opacity 250ms ease;

        &:hover {
            color: var(--color-103);
            border-color: var(--color-103);
        }
    }
}

.MainSidebar_groupBottomBorder__tYejX:only-child {
    display: none;
}

.MainSidebar_groupBottomBorder__tYejX:not(:only-child) {
    border-bottom: 1px solid var(--color-black);
    padding-top: 5px;
}

@keyframes MainSidebar_expanding__pdaOE {
    0% {
        width: 60px;
        overflow: hidden;
    }
    10% {
        overflow: auto;
    }
    100% {
        width: var(--expanded-width);
        overflow: auto;
    }
}

@keyframes MainSidebar_collapsing__S3tF0 {
    0% {
        width: var(--expanded-width);
        overflow: hidden;
    }
    100% {
        width: 60px;
        overflow: hidden;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/MainSidebar/MainSidebar.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;IACf,SAAS;IACT,sBAAsB;;IAEtB,uBAAuB;IACvB,4BAA4B;IAC5B,cAAc;;IAEd,kDAA+B;;IAE/B;QACI,2EAAwD;IAC5D;;IAEA;QACI,MAAM;QACN,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,kCAAkC;QAClC,qBAAqB,EAAE,2CAA2C;IACtE;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;QACvB,eAAe;QACf,qBAAqB;QACrB,kCAAkC;QAClC,mBAAmB;QACnB,wBAAwB;QACxB,UAAU;QACV,8BAA8B;;QAE9B;YACI,uBAAuB;YACvB,8BAA8B;QAClC;IACJ;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,4BAA4B;QAC5B,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":[".sidebarMenuGroups {\n    font-weight: 100;\n    height: calc(100vh - 75px);\n    padding-top: 15px;\n    position: fixed;\n    top: 60px;\n    box-sizing: border-box;\n\n    --expanded-width: 273px;\n    width: var(--expanded-width);\n    overflow: auto;\n\n    animation: expanding 250ms ease;\n\n    &.collapsed {\n        animation: collapsing 250ms ease 200ms 1 normal forwards;\n    }\n\n    &.mobile {\n        top: 0;\n        --expanded-width: 260px;\n        height: 100vh;\n    }\n\n    &::-webkit-scrollbar {\n        width: 9px;\n        height: 0;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        border-width: 0 2px;\n        border-style: solid;\n        background-color: var(--color-102);\n        border-color: #1a1a1a; /* we don't have this color in ui-connect */\n    }\n\n    .sidebarMenuItems {\n        margin: 0 0 5px;\n        list-style: none;\n        padding: 0;\n    }\n\n    button {\n        padding: 2px 10px;\n        color: var(--color-114);\n        font-size: 14px;\n        margin: 5px 20px 20px;\n        border: 1px solid var(--color-102);\n        border-radius: 24px;\n        width: calc(100% - 40px);\n        opacity: 1;\n        transition: opacity 250ms ease;\n\n        &:hover {\n            color: var(--color-103);\n            border-color: var(--color-103);\n        }\n    }\n}\n\n.groupBottomBorder:only-child {\n    display: none;\n}\n\n.groupBottomBorder:not(:only-child) {\n    border-bottom: 1px solid var(--color-black);\n    padding-top: 5px;\n}\n\n@keyframes expanding {\n    0% {\n        width: 60px;\n        overflow: hidden;\n    }\n    10% {\n        overflow: auto;\n    }\n    100% {\n        width: var(--expanded-width);\n        overflow: auto;\n    }\n}\n\n@keyframes collapsing {\n    0% {\n        width: var(--expanded-width);\n        overflow: hidden;\n    }\n    100% {\n        width: 60px;\n        overflow: hidden;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarMenuGroups": `MainSidebar_sidebarMenuGroups__8dbXJ`,
	"expanding": `MainSidebar_expanding__pdaOE`,
	"collapsing": `MainSidebar_collapsing__S3tF0`,
	"collapsed": `MainSidebar_collapsed__JUDKb`,
	"mobile": `MainSidebar_mobile__RXDko`,
	"sidebarMenuItems": `MainSidebar_sidebarMenuItems__J6niH`,
	"groupBottomBorder": `MainSidebar_groupBottomBorder__tYejX`
};
export default ___CSS_LOADER_EXPORT___;
